import { NONE_SELECTED, UNLABELED } from '@/features/datasets/components/DataSelection/RawRecordsStatus/constants';

export const IMPROVEMENT_MODE_TABLE_FILTER_KEYS = ['labels', 'entities', 'relations'];

function selectedValuesForKind(filters, isNerTask, showDropdown) {
    if (isNerTask) {
        const key = showDropdown === 'Relations' ? 'relations' : 'entities';
        return Array.isArray(filters[key]) ? filters[key].filter(Boolean) : [];
    }
    const labels = filters.labels;
    if (!Array.isArray(labels)) return [];
    return labels.filter((item) => item && item !== UNLABELED && item !== NONE_SELECTED);
}

/**
 * Map an Improvement Mode dropdown selection onto the Data Editor table
 * filter keys. `label` is a string, a string array (NER / multilabel), or
 * null / empty to clear. Always clears the sibling keys and review_status
 * so NER entity filters return every record that contains the entity,
 * reviewed or not.
 */
export function improvementModeFilterToTableFilters(label, kind) {
    const partial = {
        labels: null,
        entities: null,
        relations: null,
        review_status: null,
    };
    const labels = Array.isArray(label) ? label.filter(Boolean) : (label ? [label] : []);
    if (labels.length > 0 && IMPROVEMENT_MODE_TABLE_FILTER_KEYS.includes(kind)) {
        partial[kind] = labels;
    }
    return partial;
}

/**
 * Inverse of {@link improvementModeFilterToTableFilters}: every Improvement
 * Mode dropdown value currently applied on the table. Empty means All.
 * Unlabeled / None Selected table buckets are not Improvement Mode labels.
 */
export function tableFiltersToImprovementModeLabels(
    filters = {},
    isNerTask = false,
    showDropdown = 'Entities',
) {
    return selectedValuesForKind(filters, isNerTask, showDropdown);
}

/**
 * Inverse of {@link improvementModeFilterToTableFilters}: the single value
 * the Improvement Mode dropdown should show for the current table filters.
 * Returns null when none or more than one value is selected.
 */
export function tableFiltersToImprovementModeLabel(
    filters = {},
    isNerTask = false,
    showDropdown = 'Entities',
) {
    const values = tableFiltersToImprovementModeLabels(filters, isNerTask, showDropdown);
    return values.length === 1 ? values[0] : null;
}
